module.exports = __webpack_public_path__ + "static/media/ic-arrow-right-blue.fa431189.svg";